import css from 'styled-jsx/css'
import { useCallback, useEffect, useState } from 'react'
import ImageCarousel from '@ui/components/shared/ImageCarousel'
import { SyncedProp, useIsPreview, useSetting, useThrottle } from '@ui/hooks'
import { thumbImage } from '@libs/client/helpers/imagePath'
import { imagePath, previewImage } from '@ui/helpers'

type ProductImagesProps = {
  changedVariantImage: number
  activeIndexSyncedProp: SyncedProp<number>
}

function hashCode(str: string) {
  return str
    .split('')
    .reduce((prevHash, currVal) => ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0, 0)
}

const sThumb = thumbImage('96x96')
// const mThumb = thumbImage('w=500,h=500')

export default function ProductImages({
  changedVariantImage,
  activeIndexSyncedProp
}: ProductImagesProps) {
  const [sellpageSetting] = useSetting('sellpage')
  const [syncedActiveIndex, setSyncedActiveIndex] = activeIndexSyncedProp
  const isPreview = useIsPreview()
  const imgUrls = sellpageSetting?.gallery || []
  const [isMounted, setIsMounted] = useState(false)
  const throttledSyncedActiveIndex = useThrottle(syncedActiveIndex, 60)
  useEffect(() => {
    setIsMounted(true)
    setSyncedActiveIndex(0)
  }, [])
  const changeImage = (index: number) => {
    setSyncedActiveIndex(index)
  }
  const getImageThumb = useCallback(
    (index: number) => {
      if (isPreview) return previewImage(imgUrls[index])
      return sThumb(imgUrls[index])
    },
    [imgUrls]
  )
  const getImageSrc = useCallback(
    (index: number) => {
      if (isPreview) return previewImage(imgUrls[index])
      const image = imgUrls[index]
      return imagePath(image)
      // if (image.endsWith('.gif')) {
      // } else {
      //   return mThumb(image)
      // }
    },
    [imgUrls]
  )

  return (
    <div className="product-images">
      <style jsx global>
        {globalStyle}
      </style>
      {/* {isMounted && (
        <figure
          v-lazy-container="{ selector: 'img.lazy-origin' }"
          className="product-thumbnail is-square is-marginless mb-2 image"
        >
          <img
            key="syncedActiveIndex"
            data-src={imgUrls[syncedActiveIndex]}
            className="lazy-origin"
            alt=""
          />
        </figure>
      )} */}
      <figure className="product-thumbnail is-square is-marginless mb-2 image">
        {imgUrls[syncedActiveIndex] && (
          <img
            key={throttledSyncedActiveIndex}
            className={`lazyload ${hashCode(imgUrls[syncedActiveIndex])}`}
            src={getImageThumb(syncedActiveIndex)}
            data-src={getImageSrc(syncedActiveIndex)}
            alt=""
          />
        )}
      </figure>
      {isMounted && (
        <ImageCarousel
          imgUrls={imgUrls}
          activeIndex={syncedActiveIndex}
          changedVariantImage={changedVariantImage}
          onImageChange={changeImage}
        />
      )}
    </div>
  )
}

const globalStyle = css.global`
  .product-images {
    .product-thumbnail {
      margin-top: -0.75rem;
      margin-right: -0.75rem;
      margin-left: -0.75rem;

      img {
        object-fit: contain;
        background-color: white;
        border-radius: 5px;
      }
    }
  }
`
